import { Permission } from '@cims-online/shared'
import { RestoreRowActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/row'
import { simpleRestoreNotification } from 'hooks/notificationHandler'
import { useRestoreDsActionMutation } from 'schema'
import { DefaultMutationHookOptions } from 'utils/defaults'
import {
  DSAction,
  useActionsTableContext,
} from '../../../../ActionsTableContext'

export function useRestore(): RestoreRowActionOptions<DSAction> {
  const { refetch } = useActionsTableContext()
  const [restore] = useRestoreDsActionMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      restoreDSAction: {
        action: { name },
      },
    }) => simpleRestoreNotification(name),
  })
  return {
    permission: Permission.RemoveRestoreDesignSubmittalAction,
    onRestore: async ({ id }) => {
      await restore({ variables: { id } })
      refetch()
    },
    metadata: ({ deleted, deletedUser, deletedDate }) => ({
      removed: deleted,
      removedBy: deletedUser,
      removedDate: deletedDate,
    }),
    default: 'active',
  }
}
